import { FilterFormBuilder } from "components/filterForms/FilterFormBuilder/FilterFormBuilder";
import { type FilterFormPropsBase } from "components/filterForms/types/props";
import { type FC } from "react";
import { FiltersEnum } from "../types";
import { FilterViewTypes } from "enums/filterViewTypes";

export interface FilterFormProps extends FilterFormPropsBase<FiltersEnum> {
  showAccountType: boolean;
}

const getFilterItems = ({ showAccountType }: { showAccountType: boolean }) => {
  const result = [
    {
      type: FilterViewTypes.MultiSelect,
      label: "Labels",
      propertyName: FiltersEnum.Tags,
      placeholder: "All Labels",
    },
    {
      type: FilterViewTypes.DateRange,
      label: "Added Date",
      propertyName: FiltersEnum.AddedDate,
    },
  ];

  if (showAccountType) {
    result.push({
      type: FilterViewTypes.MultiSelect,
      label: "Account Type",
      propertyName: FiltersEnum.AccountType,
      placeholder: "All Account Types",
    });
  }

  return result;
};

export const FilterForm: FC<FilterFormProps> = ({
  filterOptions,
  filter,
  updateFilter,
  showAccountType,
  onValidationChange,
}) => (
  <FilterFormBuilder
    filterOptions={filterOptions}
    filter={filter}
    updateFilter={updateFilter}
    items={getFilterItems({ showAccountType })}
    onValidationChange={onValidationChange}
  />
);
